// Mirrors AI_BRIDGE_PATH_ROOT / AI_BRIDGE_PATH_REGEX in server/apps/devices/models.py.
// Keep the two in step: the backend rejects anything this lets through.
export const BRIDGE_PATH_ROOT = '/opt/visionplatform'

export const BRIDGE_PATH_PREFIX = `${BRIDGE_PATH_ROOT}/`

const SEGMENT_PATTERN = /^[A-Za-z0-9._-]+$/

// The root is fixed in the UI, so only the part below it is user-editable. Every segment
// must be a plain name — '.' and '..' would climb out of the root, and the path is handed
// to the edge device for a filesystem check.
export const isValidBridgeSubPath = (value: string) => {
  const subPath = value.trim()

  if (!subPath || subPath.startsWith('/')) {
    return false
  }

  return subPath
    .split('/')
    .every(
      (segment) =>
        SEGMENT_PATTERN.test(segment) && segment !== '.' && segment !== '..'
    )
}

export const buildBridgePath = (subPath: string) =>
  `${BRIDGE_PATH_PREFIX}${subPath.trim()}`
